<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-data-table
    :headers="getOverdueFactoringsHeaders ()"
    :items="overdueFactorings"
    :loading="loadingOverdueFactorings"
    :items-per-page="rowCount"
    :no-data-text="$t('krita.datagrid.nodata')"
    hide-actions
    align-content-center>
    <template v-slot:headers="props">
      <data-grid-sort
        :props="props"
        :pagination="pagination"
        @changeSort="changeSort"
      />
    </template>
    <template v-slot:items="props">
      <td><router-link 
        :to="{name: 'Factoring detail', params: {id: props.item.Id}}"
        target="_self">{{ props.item.Id }}</router-link></td>
      <td class="text-xs-right">{{ props.item.FactoringDueDate | date }} <span v-html="getButton(props.item.Indicator )"/></td>
      <td class="text-xs-right">{{ props.item.LeftToPay | amount }}</td>
      <td class="text-xs-right">{{ props.item.DebtorName }} ehf (kt. {{ props.item.DebtorRegistryId | kennitala }})</td>
      <!--<td>{{ props.item.Account | account}}</td>-->
      <!--<td>{{ props.item.Created | date }}</td>-->
      <td class="text-xs-right"><TwoStateButton
        :item="props.item"
        class="btn"
        @changeState="changeState" /></td>
      <template
        slot/>
    </template>
  </v-data-table>
</template>

<script>
import DataGridSort from '../controllers/DataGridSort'
import TwoStateButton from '../controllers/TwoStateButton.vue';
    export default {
        name: "OverdueFactoringsDatagrid",
        components: {TwoStateButton, DataGridSort},
        props: ['overdueFactorings','loadingOverdueFactorings','rowCount'],
        data () {
          return {
            pagination:
                    {
                      sortBy: 'factoringDueDate',
                      descending: false
                    }
          }
        },
        methods: {
            getOverdueFactoringsHeaders ()
            {
                return [
                    {sortable: true, text: this.$t('krita.claims.id'), value: 'id', align: 'left'},
                    {sortable: true, text: this.$t('krita.claims.factoringduedate'), value: 'factoringDueDate', align: 'right'},
                    {sortable: false, text: this.$t('krita.claims.lefttopay'), value: 'leftToPay', align: 'right'},
                    {sortable: false, text: this.$t('krita.claims.debtornamekennitala'), value: 'debtorInfo', align: 'right'},
                    {sortable: false, text: '', value: 'placeholder', align: 'right'}
                ]
            },
            getButton(type)
            {
                switch (type) {
                    case "soon":
                        return '<span style="border-radius: 5px; padding: 2px; background-color: #52BE80 !important; color: white;">'+this.$t('krita.indicator.soon')+'</span>';
                    case "overdue":
                        return '<span style="border-radius: 5px; padding: 2px; background-color: #d97572 !important; color: white;">'+this.$t('krita.indicator.overdue')+'</span>';
                  case "due":
                    return '<span style="border-radius: 5px; padding: 2px; background-color: #EB984E !important; color: white;">'+this.$t('krita.indicator.due')+'</span>';
                }
            },
            changeState (item)
            {
                let self = this;

              console.log(item);
                self.$emit('changeOverdueFactoringsStatus',item)
            },
            changeSort (sort)
            {
                let self = this;

                self.pagination.sortBy = sort.sortBy;
                self.pagination.descending = sort.descending;
                self.$emit('refreshWithSort',self.pagination);
            }
        }
    }
</script>

<style scoped>
    .btn {
        width:100px;
        max-width:100px;
    }
</style>
